/**
 * DEFAULT PLUGIN
 *
 * This plugin allows developers to use a new prop 'onEditingChange'.
 *
 * Returns true when editing starts, and false when editing stops.
 *
 * To be used with react state, like isEditing for example.
 */
export const EditEventsPlugin = () => {
    return {
        augmentOptions: (options, ctx) => {
            return {
                ...options,
                onCellEditingStarted: (e) => {
                    ctx.onEditingChange?.(true);
                    options?.onCellEditingStarted?.(e);
                },
                onCellEditingStopped: (e) => {
                    // confirm grid isn't still editing something else
                    const stillEditing = e.api.getEditingCells().length > 0;
                    ctx.onEditingChange?.(stillEditing);
                    options?.onCellEditingStopped?.(e);
                },
            };
        },
    };
};
